export default __webpack_public_path__ + "static/media/180-deg.63cb1a29.svg";